export const ROUTE_LOGIN = '/login';
export const ROUTE_LOAN = '/loan/order';
export const ROUTE_BANKSLIP = '/loan/bankslip';
export const ROUTE_CONCILIATIONS = '/loan/conciliations';
export const ROUTE_EMPLOYEES = '/loan/employee';
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_INVOICES = '/supply/invoices';
export const ROUTE_CONDO_INDICA = '/suppliers';
